import { AccessLevel } from '../types/AccessLevel';

// The backend's metadata.reason when a superuser tries to change their own access level.
export const OWN_ACCESS_LEVEL = 'ownAccessLevel';

export const ownAccessLevelMessage = 'Du kan inte ändra din egen behörighet.';
export const onlySuperUserMessage = 'Bara en superanvändare kan ändra behörighet.';

type Person = { accessLevel?: AccessLevel | string | null; email?: string | null };

/**
 * Why the logged-in user may not change the role of the employee the form holds, or undefined
 * when they may. It mirrors the backend: only a superuser changes a stored employee's role, and
 * never their own. A new employee has no stored role, so any role may be chosen. The user is
 * matched by email, as the backend matches the caller: their `id` is the anställningsnummer,
 * not the employee's id.
 */
export const accessLevelLockReason = (
  user: Person | null | undefined,
  storedEmployee: Person | null | undefined
): string | undefined => {
  if (!storedEmployee) {
    return undefined;
  }
  if (user?.accessLevel !== AccessLevel.SuperUser) {
    return onlySuperUserMessage;
  }
  if (user.email && user.email.toLowerCase() === storedEmployee.email?.toLowerCase()) {
    return ownAccessLevelMessage;
  }
  return undefined;
};
